import { atom } from 'nanostores'
import type { ItemContent } from '~/types/delivery'
import { Loading } from '~/lib/loading'
import { queryClient } from '~/lib/query-client'

export interface ItemBase {
  title: string
  icon: string
  label?: string
  bgAnimType: 1 | 2 | 3
  resultBgColor: string
  resultTextGradient?: string
  type: ItemContent['type']
  value: number
  isBigPrize: boolean
}

export interface Item extends ItemBase {
  originalItem?: ItemBase
}

export type PreviewAnimState = { variant: 'normal' } | { variant: 'big' }

interface State {
  previewAnim: null | PreviewAnimState
  items: null | Item[]
  currentIndex: number
}

const initialState: State = {
  previewAnim: null,
  items: null,
  currentIndex: 0,
}

export const $rewardFlowState = atom<State>(initialState)

let complete: Loading<void>

export const rewardFlow = {
  start(state: { previewAnim: PreviewAnimState | null; items: Item[] }) {
    $rewardFlowState.set({
      ...state,
      currentIndex: 0,
    })
    complete = new Loading()
    return complete.promise
  },
  next() {
    const state = $rewardFlowState.get()
    // is at last item? Complete the flow
    if (state.items && state.currentIndex === state.items.length - 1) {
      const coinDelta = state.items
        .filter((i) => i.type === 'coin')
        .reduce((sum, i) => sum + i.value, 0)
      const gemDelta = state.items
        .filter((i) => i.type === 'gem')
        .reduce((sum, i) => sum + i.value, 0)
      $rewardFlowState.set({ ...initialState })
      queryClient.setQueryData<{
        coin: number
        gem: number
        updated_at: string
      }>(
        ['balance'],
        (prev) =>
          prev && {
            ...prev,
            coin: prev.coin + coinDelta,
            gem: prev.gem + gemDelta,
          },
      )
      complete.done()
      return
    }
    $rewardFlowState.set({
      ...state,
      currentIndex: state.currentIndex + 1,
    })
  },
  endPreviewAnim() {
    const state = $rewardFlowState.get()
    $rewardFlowState.set({ ...state, previewAnim: null })
  },
}
